export enum RBACPermissions {
  CAN_SUBSCRIPTION = 'CAN_SUBSCRIPTION',
  CAN_ANNUAL_SUBSCRIPTION = 'CAN_ANNUAL_SUBSCRIPTION',
}
